import React, { useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import { Layout } from '../components/layout/layout'
import { Container, Grid, Paper, Typography } from '@material-ui/core'
import SectionItem from '../pages/section'
import { useAnalyticsEvents } from '../analytics/events.home'

const Page = ({ data, pageContext }) => {
  const pageData = data?.prismicPage?.data

  const { sections } = pageContext
  const filteredSections = sections?.filter((section) => !!section?.prismicId)

  const { homePageViewEvent } = useAnalyticsEvents()
  useEffect(() => {
    homePageViewEvent(data?.prismicPage?.lang)
  }, [])

  return (
    <Layout isNested={!!process.env.GATSBY_NESTED_FAQ}
      appbartext={pageData?.appbartext}
      footerbuttons={pageData?.footerbuttons}
      footertext={pageData?.footertext}
      lang={data?.prismicPage?.lang}
      page={"HomePage"}
    >
      <Container>
        <Grid>
          {filteredSections.map((section) => {
            return <SectionItem item={section} key={section?.prismicId} lang={data?.prismicPage?.lang} />
          })}
        </Grid>
      </Container>
    </Layout>
  )
}
export default Page

export const pageQuery = graphql`
  query PageQuery($lang: String!, $prismicId: ID!) {
    prismicPage(lang: { eq: $lang }, prismicId: { eq: $prismicId }){
      id
      prismicId
      lang
      data{
        key{
          text
        }
        appbartext{
          text
        }
        footertext{
          text
        }
        footerbuttons{
          buttonicon{
            url
          }
          buttontext{
            text
          }
          buttonlink{
            url
          }
          buttontextcolor
          buttonbackgroundcolor
        }
        sections{
          section{
            lang
            slug
            id
          }
        }
      }
    }
  }
`